import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  setCoords,
  setIndexAndCoords,
  setAvailableDates,
  storeFilter,
  setDay,
  getCurrentStore,
  booking,
  setFilterStore
} from './../Actions/Booking.action';
import { string, object, number } from 'yup';
import BookingFormEmbedded from './BookingFormEmbedded';
import { get } from '../Services/http';
import { translate } from '../Services/translation';
import { TimeSelect } from './bookingForm/timeSelect';
import { DateSelect } from './bookingForm/dateSelect';
import { storeIdConverter } from '../Services/StoreId.service';
import { toast } from "react-toastify";

const showCurrentLocation = (props) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => setCoords({
        lat: coords.latitude,
        lng: coords.longitude
      })
    )
  }
};

const selectedStore = (store) => {
  return <div className="store-details" data-member-id={store.storeId} data-member-name={store.storeName}>
    <a className="name" href={store.urlToStore}>{`${store.index ? store.index + '. ' : ""}${store.storeName}`}</a>
    <div className="address">{`${store.storeAddress}, ${store.storePostalCode} ${store.storeCity}`}</div>
    <div className="phone_bold">{`${store.storePhone ? (store.storePhone.toString().replace(/\B(?=(\d{2})+(?!\d))/g, " ")) : ""}`}</div>
  </div>
}


const BookingForm = props => {
  const { filteredStores, headerSlotHtml, dates, day, filterString, errorObject, 
    isUserRequest, stores, selectedStoreIndex } = useSelector((state) => state.booking);
    const dispatch = useDispatch();
  const [isFormShown, showForm] = useState(false);
  const [isStorePageShown, setStorePage] = useState(false);
  const [isSuccessForm, showSuccessForm] = useState(false);
  const [isFullForm, showFullForm] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [errors, setErrors] = useState({});
  const [member, setMember] = useState(null);
  const searchRef = useRef(null);
  const formRef = useRef(null);
  const currentStore = props.currentStore && JSON.parse(props.currentStore) || getCurrentStore() || {};
  const [isEForm, setIsEForm] = useState(false);
  const getAllActiveMembersUrl = props.domainName + '/api/booking/getallactivemembers/';
  const getMember = async (memberId) => {
  const storeId = storeIdConverter(memberId.toString()).asNumber;

    //? This code only for test comment this line.
    // const eMemberList = [{ "memberId": 338, "memberNo": 5128, "companyName": "Hokksund Optiske", "allowSelectResource": true },
    // { "memberId": 344, "memberNo": 5025, "companyName": "Optiker Rønning", "allowSelectResource": true },
    // { "memberId": 373, "memberNo": 5121, "companyName": "Mosand Optikk", "allowSelectResource": true },
    // { "memberId": 403, "memberNo": 5005, "companyName": "K. Hansen Optik", "allowSelectResource": true },
    // { "memberId": 406, "memberNo": 5032, "companyName": "Optiker Vestøl AS", "allowSelectResource": false },
    // { "memberId": 407, "memberNo": 5039, "companyName": "Din Optiker as", "allowSelectResource": true },
    // { "memberId": 408, "memberNo": 5041, "companyName": "Optikar Bjelland  AS", "allowSelectResource": false },
    // { "memberId": 411, "memberNo": 5098, "companyName": "Solberg Ur-Optikk AS", "allowSelectResource": true },
    // { "memberId": 412, "memberNo": 5100, "companyName": "Lorgnetten", "allowSelectResource": true },
    // { "memberId": 416, "memberNo": 5075, "companyName": "Tynset Optiske AS", "allowSelectResource": true },
    // { "memberId": 417, "memberNo": 5142, "companyName": "Brillehuset AS", "allowSelectResource": true },
    // { "memberId": 426, "memberNo": 5029, "companyName": "Arendal Optikk AS", "allowSelectResource": false },
    // { "memberId": 439, "memberNo": 5164, "companyName": "Sellebakk Synssenter AS", "allowSelectResource": true },
    // { "memberId": 452, "memberNo": 5170, "companyName": "Hitz Optikk AS", "allowSelectResource": false },
    // { "memberId": 454, "memberNo": 5171, "companyName": "C-Optikk Sødorptunet", "allowSelectResource": true },
    // { "memberId": 472, "memberNo": 5020, "companyName": "C-Optikk Nittedal AS", "allowSelectResource": false },
    // { "memberId": 473, "memberNo": 5153, "companyName": "Gran Optikk", "allowSelectResource": true },
    // { "memberId": 474, "memberNo": 5033, "companyName": "Tvedt Optikk", "allowSelectResource": true },
    // { "memberId": 483, "memberNo": 5143, "companyName": "Brillehjørnet Molde AS", "allowSelectResource": true },
    // { "memberId": 484, "memberNo": 5165, "companyName": "Gundersen & Løken Optikk AS", "allowSelectResource": false },
    // { "memberId": 505, "memberNo": 5144, "companyName": "Synsenteret Florø AS", "allowSelectResource": true },
    // { "memberId": 511, "memberNo": 5132, "companyName": "Son Optikk AS", "allowSelectResource": true },
    // { "memberId": 609, "memberNo": 5019, "companyName": "Optikkhuset Grimstad", "allowSelectResource": false },
    // { "memberId": 611, "memberNo": 5024, "companyName": "Holmestrand Optikk AS", "allowSelectResource": false },
    // { "memberId": 612, "memberNo": 5027, "companyName": "C-optikk Hvittingfoss", "allowSelectResource": false },
    // { "memberId": 618, "memberNo": 5042, "companyName": "Notodden Optikk", "allowSelectResource": true },
    // { "memberId": 624, "memberNo": 5054, "companyName": "Vagle Optikk AS", "allowSelectResource": true },
    // { "memberId": 628, "memberNo": 5062, "companyName": "Slemmestad Optikk AS", "allowSelectResource": false },
    // { "memberId": 635, "memberNo": 5074, "companyName": "Optiker Lundemo AS", "allowSelectResource": false },
    // { "memberId": 636, "memberNo": 5076, "companyName": "Tønsberg Optiske A/S", "allowSelectResource": true },
    // { "memberId": 637, "memberNo": 5077, "companyName": "Havblikk Optikk A/S", "allowSelectResource": true },
    // { "memberId": 645, "memberNo": 5101, "companyName": "Optikk Volda", "allowSelectResource": true },
    // { "memberId": 647, "memberNo": 5104, "companyName": "Optiker Viksveen AS", "allowSelectResource": false },
    // { "memberId": 649, "memberNo": 5110, "companyName": "Kleppestø Optikk AS", "allowSelectResource": true },
    // { "memberId": 654, "memberNo": 5115, "companyName": "Størseth Optikk AS", "allowSelectResource": false },
    // { "memberId": 657, "memberNo": 5122, "companyName": "Koren Optikk AS", "allowSelectResource": false },
    // { "memberId": 661, "memberNo": 5127, "companyName": "Lierbyen Optikk AS", "allowSelectResource": false },
    // { "memberId": 662, "memberNo": 5130, "companyName": "Tvedt Optikk AS", "allowSelectResource": true },
    // { "memberId": 663, "memberNo": 5131, "companyName": "Liens Optiske AS", "allowSelectResource": true },
    // { "memberId": 667, "memberNo": 5137, "companyName": "Bekkestua Optikk AS", "allowSelectResource": true },
    // { "memberId": 670, "memberNo": 5146, "companyName": "OK Hagen AS", "allowSelectResource": false },
    // { "memberId": 672, "memberNo": 5149, "companyName": "Lillesand Optikk AS", "allowSelectResource": true },
    // { "memberId": 677, "memberNo": 5159, "companyName": "Brattvåg Synssenter AS", "allowSelectResource": false },
    // { "memberId": 678, "memberNo": 5160, "companyName": "Vinderen Optik", "allowSelectResource": false },
    // { "memberId": 679, "memberNo": 5161, "companyName": "Brillespesialisten AS", "allowSelectResource": false },
    // { "memberId": 682, "memberNo": 5167, "companyName": "Ses Optikk AS", "allowSelectResource": true },
    // { "memberId": 685, "memberNo": 5172, "companyName": "Koren Optikk Trondheim AS", "allowSelectResource": true },
    // { "memberId": 687, "memberNo": 5176, "companyName": "SmartLook Optikk AS", "allowSelectResource": true },
    // { "memberId": 691, "memberNo": 5147, "companyName": "Drecker Design AS", "allowSelectResource": true },
    // { "memberId": 705, "memberNo": 5182, "companyName": "Rakkestad Optikk AS", "allowSelectResource": true },
    // { "memberId": 710, "memberNo": 5183, "companyName": "Olsrød Optikk AS", "allowSelectResource": true },
    // { "memberId": 729, "memberNo": 5189, "companyName": "C Optikk Eidsvoll AS", "allowSelectResource": false },
    // { "memberId": 737, "memberNo": 5191, "companyName": "Optikk og Syn AS", "allowSelectResource": true },
    // { "memberId": 748, "memberNo": 5991, "companyName": "Oles c)optikk", "allowSelectResource": true },
    // { "memberId": 750, "memberNo": 5192, "companyName": "Øyesenteret Jessheim", "allowSelectResource": true },
    // { "memberId": 762, "memberNo": 5197, "companyName": "Lauvland Optikk AS", "allowSelectResource": false },
    // { "memberId": 782, "memberNo": 5203, "companyName": "Sandnes Optikk AS", "allowSelectResource": true },
    // { "memberId": 788, "memberNo": 5206, "companyName": "Larsen Optikk AS", "allowSelectResource": false },
    // { "memberId": 790, "memberNo": 5208, "companyName": "Strauman Optikk AS", "allowSelectResource": true },
    // { "memberId": 792, "memberNo": 5209, "companyName": "Erøy Optikk", "allowSelectResource": false },
    // { "memberId": 793, "memberNo": 5210, "companyName": "Briskeby Optikk", "allowSelectResource": false },
    // { "memberId": 796, "memberNo": 5213, "companyName": "c)optikk Revetal", "allowSelectResource": true },
    // { "memberId": 799, "memberNo": 5212, "companyName": "Brillehjørnet Lillehammer AS", "allowSelectResource": true },
    // { "memberId": 802, "memberNo": 5218, "companyName": "Brillehuset Brønnøysund AS", "allowSelectResource": true },
    // { "memberId": 803, "memberNo": 5219, "companyName": "Jacob Friis Ur-Optikk AS", "allowSelectResource": true },
    // { "memberId": 806, "memberNo": 5225, "companyName": "c)optikk Spiten", "allowSelectResource": false },
    // { "memberId": 807, "memberNo": 5226, "companyName": "C)Optikk Hardanger AS", "allowSelectResource": true },
    // { "memberId": 811, "memberNo": 5227, "companyName": "Synsrådgivning AS", "allowSelectResource": false },
    // { "memberId": 812, "memberNo": 5230, "companyName": "Brilleriet Stord", "allowSelectResource": false },
    // { "memberId": 813, "memberNo": 5228, "companyName": "C-optikk Namsos ", "allowSelectResource": true },
    // { "memberId": 815, "memberNo": 5229, "companyName": "C-Optikk Rørvik", "allowSelectResource": true },
    // { "memberId": 824, "memberNo": 5232, "companyName": "Brilleriet Heiane AS", "allowSelectResource": false },
    // { "memberId": 828, "memberNo": 5234, "companyName": "Kongsvinger Optiske AS", "allowSelectResource": true },
    // { "memberId": 829, "memberNo": 5236, "companyName": "C Godt AS", "allowSelectResource": false },
    // { "memberId": 845, "memberNo": 5237, "companyName": "C-bra Optikk AS", "allowSelectResource": false },
    // { "memberId": 847, "memberNo": 5238, "companyName": "Hugo Farstad", "allowSelectResource": true },
    // { "memberId": 848, "memberNo": 5239, "companyName": "Brillehuset Evenskjer", "allowSelectResource": true },
    // { "memberId": 849, "memberNo": 5240, "companyName": "Brillehuset Bardufoss", "allowSelectResource": false },
    // { "memberId": 852, "memberNo": 5243, "companyName": "Wentzel Optikk Langevåg AS", "allowSelectResource": false },
    // { "memberId": 854, "memberNo": 5245, "companyName": "Optiker Ø Krogh Ski", "allowSelectResource": false },
    // { "memberId": 855, "memberNo": 5246, "companyName": "Optiker Ø Krogh Avd Ås", "allowSelectResource": false },
    // { "memberId": 858, "memberNo": 5247, "companyName": "Optiker 1", "allowSelectResource": true },
    // { "memberId": 870, "memberNo": 5253, "companyName": "Optiker Ø Krogh Avd Vestby", "allowSelectResource": false },
    // { "memberId": 879, "memberNo": 5254, "companyName": "Nordfjord Optikk AS", "allowSelectResource": false },
    // { "memberId": 886, "memberNo": 5256, "companyName": "Brillehuset Ranheim AS", "allowSelectResource": false },
    // { "memberId": 891, "memberNo": 5257, "companyName": "Dombås Optikk", "allowSelectResource": false },
    // { "memberId": 902, "memberNo": 5258, "companyName": "Alver Optikk", "allowSelectResource": false },
    // { "memberId": 911, "memberNo": 5261, "companyName": "M&M Optikk AS", "allowSelectResource": true },
    // { "memberId": 912, "memberNo": 5263, "companyName": "Vinstra Synsenter", "allowSelectResource": true },
    // { "memberId": 918, "memberNo": 5265, "companyName": "Oppdal Synsenter AS", "allowSelectResource": true },
    // { "memberId": 919, "memberNo": 5266, "companyName": "Sem Optikk AS", "allowSelectResource": true }];
    const eMemberList = await get(getAllActiveMembersUrl, null, 'omit').then(resp => resp.json());
    const currentMember = eMemberList.find(({ memberNo }) => memberNo === storeId);
    setMember(currentMember);
    setIsEForm(!!currentMember);
    setStorePage(props.isStorePage);
    showForm(true);
    if (window != null && window.dataLayer != null) {
      let trackingObject = {
        event: "booking_start",
        storeId: storeIdConverter(memberId).withC,
        storeName: currentStore.storeName
      };
      console.log(trackingObject);
      window.dataLayer.push(trackingObject);
    }

    if (!isEForm) {
      await setAvailableDates(storeIdConverter(memberId).withC, dispatch);
    }
  }

  useEffect(() => {
    if (errorObject && errorObject.message) {
      toast(errorObject.message, {
        position: "bottom-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [errorObject]);

  useEffect(() => {
    if (props.memberId) {
      getMember(props.memberId);
    }
    setBookingData(prevData => ({ ...prevData, customerResponseType: 0 }));
  }, []);
  useEffect(() => {
    const currentOptician = (new URLSearchParams(window.location.search)).get('current_optician');
    if (currentOptician && filteredStores && filteredStores.length && (filterString === null)) {
      setIndexAndCoords(filteredStores.find(store => store.storeId == currentOptician).index, stores, dispatch);
      getMember(currentOptician);
    }

    if (!props.isStorePage && currentOptician === null) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          ({ coords }) => orderFilteredStores(
            coords.latitude,
            coords.longitude
          )
        )
      }
    }    
  }, [filteredStores.length]);  
  

  const orderFilteredStores = (lat, lng) => {
    if (lat && lng) {
      let nearestStores = [];
      filteredStores.forEach((store) => {
          nearestStores.push({
              index: store.index,
              distance: getDistanceFromLatLonInKm(store.lat, store.lng, lat, lng)
          });
      });
      nearestStores.sort((a, b) => {
          return a.distance - b.distance;
      });
  
      const nearestStoresIndexes = nearestStores.map(store => store.index);
      dispatch(setFilterStore(filteredStores.sort((a, b) => nearestStoresIndexes.indexOf(a.index) - nearestStoresIndexes.indexOf(b.index))));
    }  
  }  

  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

const deg2rad = (deg) => {
    return deg * (Math.PI / 180)
}


  const resetForm = () => {
    setIsEForm(false);
    showForm(false);
    showSuccessForm(false);
    showFullForm(false);
    setBookingData({});
    setErrors({});
    setMember(null);
  }
  const onDateSelect = (date) => {
    dispatch(setDay(date));
    onBookingDataChange('calendarDate', date)
  };
  const onBookingDataChange = (key, value) => {
    setBookingData(prevData => ({ ...prevData, [key]: value }));
    if (key == 'timeSlot') {
      if (window != null && window.dataLayer != null) {
        let trackingObject = {
          event: "booking_planned",
          booking_data: {
            dateTime: bookingData.calendarDate + ' ' + bookingData.time
          },
          storeId: storeIdConverter(currentStore.storeId).withC,
          storeName: currentStore.storeName
        };
        console.log(trackingObject);
        window.dataLayer.push(trackingObject);
      }
    }
  }
  useEffect(() => {
    const { calendarDate, timeSlot } = bookingData;
    showFullForm(!!calendarDate && !!timeSlot && timeSlot !== "Ønsket tid")
  }, [bookingData]);

  const showSuccess = () => {
    bookingData.storeId = props.memberId ? props.memberId : storeIdConverter(currentStore.storeId).withC;
    bookingData.time = undefined;
    const date = new Date(bookingData.calendarDate);
    date.setUTCHours(22);
    date.setDate(date.getDate() + 1);
    bookingData.calendarDate = date;
    bookingData.customerResponseType = bookingData.customerResponseType;
    bookingData.storeName = currentStore.storeName;

    const bookingSchema = object().shape({
      storeId: string().required(translate(`validation.required`)),
      storeName: string().required(translate(`validation.required`)),
      calendarDate: string().required(translate(`validation.required`)),
      customerPhone: string().required(translate(`validation.required`)).matches(/^[0-9]+$/, "Must be only digits").min(8, 'Must be exactly 8 digits').max(8, 'Must be exactly 8 digits'),
      customerResponseType: number().required(translate(`validation.required`)),
      customerEmail: string().email(),
      customerMessage: string().nullable(),
      customerName: string().required(translate(`validation.required`)),
      timeSlot: string().required(translate(`validation.required`)),
    });

    bookingSchema.validate(bookingData, { abortEarly: false })
      .then(() => {
        return booking(bookingData);
      })
      .then(({ status }) => {
        if (status === 200) {
          if (window != null && window.dataLayer != null) {
            let trackingObject = {
              event: "booking_complete",
              booking_data: {
                dateTime: bookingData.calendarDate + ' ' + bookingData.time,
                responseType: bookingData.customerResponseType
              },
              storeId: storeIdConverter(currentStore.storeId).withC,
              storeName: currentStore.storeName
            };
            console.log(trackingObject);
            window.dataLayer.push(trackingObject);
          }
          showSuccessForm(true);
        } else {
          setErrors({ message: 'Error, Status: ' + status });
        }
      })
      .catch(error => {
        if (error && error.response) {
          error.response.json().then(err => {
            setErrors(err);
          })
        } else
          if (error && error.inner) {
            setErrors(error.inner.map(({ path, type }) => ({ [path]: { type } })).reduce((r, c) => ({ ...r, ...c })));
          } else {
            setErrors({ message: error });
          }
      });
  };
  const searchParams = (new URLSearchParams(window.location.search)).get('single');
  const storeForm = <form className="user-form" ref={formRef}>
    <div className="row">
      {!props.memberId ? <>
        {!searchParams ?
          <div className="columns small-12">
            <button type="button" className="button return-btn go-back" onClick={resetForm}>
              <span className="small-arrow ic ic-left-arrow" /> {translate('select_optician.name')}
            </button>
          </div> : null
        }
        <div className="columns small-12">
          <div className="single-store selected" key={`user-form-selectedStore ${props.memberId}`}>
            {selectedStore(currentStore)}
          </div>
        </div>
      </> : null}
      <div className="columns small-6">
        <DateSelect dates={dates} value={bookingData.calendarDate} onChange={onDateSelect} />
        <span className='error'> {errors.calendarDate && errors.calendarDate.type === 'required' && translate('baseform.date.error.required')}</span>
      </div>
      <div className="columns small-6 store-field-wrapper">
        <TimeSelect day={day} dates={dates} value={bookingData.timeSlot} onChange={(event) => onBookingDataChange('timeSlot', event.target.value)} />
      </div>
    </div>
    {isFullForm ? <div className={`row store-booking-details ${isFullForm ? "visible" : ""}`} >
      <div className="columns small-12 store-field-wrapper">
        <input className="store-field" type="text" placeholder={translate('baseform.name.placeholder')} autoComplete="off" value={bookingData.customerName || ''} onChange={(event) => onBookingDataChange('customerName', event.target.value)} />
        <span className='error'> {errors.customerName && errors.customerName.type === 'required' && translate('baseform.name.error.required')}</span>
      </div>
      <div className="columns small-6 store-field-wrapper">
        <input className="store-field" type="search" placeholder={translate('baseform.phone.placeholder')} autoComplete="off" value={bookingData.customerPhone || ''} onChange={(event) => onBookingDataChange('customerPhone', event.target.value)} />
        <span className='error'> {errors.customerPhone && errors.customerPhone.type === 'required' && translate('baseform.phone.error.required')}</span>
        <span className='error'> {errors.customerPhone && errors.customerPhone.type !== 'required' && translate('baseform.phone.error.pattern')}</span>
      </div>
      <div className="columns small-6 store-field-wrapper">
        <select className="custom-select" onChange={(event) => onBookingDataChange('customerResponseType', event.target.value)}>
          <option value={0}>{translate('SMS')}</option>
          <option value={1}>{translate('Telefon')}</option>
          <option value={2}>{translate('Epost')}</option>
        </select>
        <span className='error'> {errors.customerResponseType && errors.customerResponseType.type === 'required' && translate('baseform.customerResponseType.error.required')}</span>
      </div>
      <div className="columns small-12 store-field-wrapper">
        <input className="store-field" type="email" placeholder={translate('baseform.email.placeholder')} autoComplete="off" value={bookingData.customerEmail || ''} onChange={(event) => onBookingDataChange('customerEmail', event.target.value)} />
        <span className='error'> {errors.customerEmail && translate('baseform.email.error.pattern')}</span>
      </div>
      <div className="columns small-12 store-field-wrapper">
        <textarea className="expanded big-text-container store-field" placeholder={translate('baseform.customerMessage.placeholder')} autoComplete="off" value={bookingData.customerMessage || ''} onChange={(event) => onBookingDataChange('customerMessage', event.target.value)} />
      </div>
      <div className="columns small-12 " dangerouslySetInnerHTML={{ __html: window.__litium.bookingWarningMessage }}>
      </div>
      {errors && errors.message ? (
        <div className="columns errorMsg">
          <h5>Error</h5>
          <p>
            {errors.message}
          </p>
        </div>
      ) : null}
      <div className="columns small-12">
        <button type="button" className="button expanded return-btn submit-button" onClick={showSuccess} >{translate('coptikk.booking.fallbackemailbookingtext')}</button>
      </div>
    </div> : null}
  </form>
  return <div className='booking__form'>
    <div className={`store-booking-step ${isSuccessForm ? "visible" : ""}`}>

      {currentStore ? <div className="row">
        <div className="columns small-12" dangerouslySetInnerHTML={{ __html: window.__litium.bookingSuccessMessage }}>

        </div>
      </div>
        : null}

    </div>
    {isFormShown && !isSuccessForm ? <div className={`store-booking-step ${isFormShown && !isSuccessForm ? "visible" : ""}`}>
      {isEForm && !isStorePageShown ? <BookingFormEmbedded isUserRequest={isUserRequest} showMember={!props.memberId} allowSelectResource={member.allowSelectResource} member={member} onReturn={resetForm} currentStore={currentStore} domainName={props.domainName} /> : null}
      {!isEForm ? storeForm : null}
      {isEForm && isStorePageShown ? <a href={`${window.__litium.baseBookingUrl}?single=true&current_optician=${storeIdConverter(props.memberId ? props.memberId : currentStore.storeId).asNumber}`} className="button primary store-booking-step-link" title={translate('optician.booking.btn.title')}>{translate('optician.booking.btn.title')}</a> : null}
    </div> : null}
    {!isFormShown && !isSuccessForm ?
      <div className={`store-list-step ${!isFormShown && !isSuccessForm ? "visible" : ""}`}>
        {!props.memberId ?
          <div className="store-filter">
            <input ref={searchRef} className="search" type="search" placeholder={translate('find_optician.placeholder')}
              autoComplete="off" value={filterString || ""} onChange={() => dispatch(storeFilter(searchRef.current.value, stores, dispatch))} />
            <span className="magnifier-btn"></span>
            <span className="geolocation-btn" onClick={() => showCurrentLocation(props)}></span>
          </div>
          : null}
        <div className="stores-wrapper">
          {filteredStores && filteredStores.length > 0 && filteredStores.map((currentStore) => <div
            key={currentStore.storeId + currentStore.id + currentStore.index + 'store-key'}
            ref={ref => {
              if(currentStore.index && (selectedStoreIndex === currentStore.index) && ref ) {
                var topPos = ref.offsetTop;
                var excludeFilter = ref.previousElementSibling && ref.previousElementSibling.scrollHeight;
                var total = topPos - excludeFilter;
                ref.parentElement.scrollTo({top: total, behavior: "smooth" });
              }
            }}
            className={`single-store ${!selectedStoreIndex || selectedStoreIndex === currentStore.index ? "selected" : ""}`}
            onClick={() => setIndexAndCoords(currentStore.index, stores, dispatch)}>
            {selectedStore(currentStore)}
            <div className="store-action">
              <button type="button" className="button select-store-btn" onClick={() => getMember(currentStore.storeId)} data-storeid={storeIdConverter(currentStore.storeId).withC} data-storename={currentStore.storeName}>
                {translate('homepage_bookingappointment.buttontext')}
              </button>
            </div>
          </div>
          )}
        </div>
      </div> : null}
  </div>
}

export default BookingForm;